// Shared formatting for the recurring-shuttle surfaces — the customer quote card
// (CharterQuoteCard) and the dispatcher summary (CharterDispatchApp's ShuttleSummary) — so the two
// views humanize a shuttle's schedule identically. Pure functions, no React.
//
//   humanizeRecurrenceDays("MON,TUE,…")  ->  "every day" | "Mon–Fri" | "Mon, Wed, Fri"
//   fmtClock("HH:mm")                    ->  "7:00 AM"   (non-parseable input echoes back raw)

export const RECURRENCE_DAY_ORDER = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
export const RECURRENCE_DAY_LABELS = { MON: 'Mon', TUE: 'Tue', WED: 'Wed', THU: 'Thu', FRI: 'Fri', SAT: 'Sat', SUN: 'Sun' };

// Humanize the "MON,TUE,..." recurrence tokens: blank or all seven -> "every day" (mid-sentence
// lowercase — capitalize at the call site if it must open a line); a contiguous Mon..Sun run ->
// "Mon–Fri"; anything else -> a comma list ("Mon, Wed, Fri"). Unknown tokens are dropped rather
// than rendered raw.
export function humanizeRecurrenceDays(tokens) {
  const idx = [...new Set(
    String(tokens || '').split(',')
      .map((t) => RECURRENCE_DAY_ORDER.indexOf(t.trim().toUpperCase()))
      .filter((i) => i >= 0)
  )].sort((a, b) => a - b);
  if (idx.length === 0 || idx.length === 7) return 'every day';
  if (idx.length > 1 && idx[idx.length - 1] - idx[0] === idx.length - 1) {
    return `${RECURRENCE_DAY_LABELS[RECURRENCE_DAY_ORDER[idx[0]]]}–${RECURRENCE_DAY_LABELS[RECURRENCE_DAY_ORDER[idx[idx.length - 1]]]}`;
  }
  return idx.map((i) => RECURRENCE_DAY_LABELS[RECURRENCE_DAY_ORDER[i]]).join(', ');
}

// 24h "HH:mm" -> the 12-hour clock style both shuttle views use ("07:00" -> "7:00 AM").
// Non-parseable input echoes back raw so a bad payload never renders as "Invalid Date".
export function fmtClock(hhmm) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || '').trim());
  if (!m) return String(hhmm || '');
  const h = Number(m[1]);
  return `${h % 12 || 12}:${m[2]} ${h >= 12 ? 'PM' : 'AM'}`;
}
